import intlFormatter from './currency';

const formatValue = (val, opts, noMax = false) => {
  const { type, ISO } = opts.apply ?? opts;

  const options = {
    minimumFractionDigits: val % 1 ? 2 : 0,
  };

  if (Number.isNaN(val) || val === '—') {
    return val;
  }

  if (type === 'currency') {
    return intlFormatter(val, ISO, noMax).replace('-', '–');
  }

  if (type === 'percent') {
    return `${val}%`.replace('-', '–');
  }
  return new Intl.NumberFormat('en-US', options).format(val).replace('-', '–');
};

export default formatValue;
